export default () => {

    const modalTriggers = document.querySelectorAll('[data-modal]');

    if(!modalTriggers.length) {
        return;
    }

    const modalAjaxCall = (modalId) => {
        return fetch('/api/v1/modal', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                modalId: modalId,
            }),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error('Something went wrong');
            }
        }).then(({message}) => {
            return message;
        }).catch((error) => {
            console.log(error);
        });
    }

    const getModalContent = (modalId) => {
        const modalIdNumber = parseInt(modalId);
        if(!Number.isInteger(modalIdNumber)) {
            return;
        }

        return modalAjaxCall(modalIdNumber);
    }

    const appendModal = (modal) => {
        const body = document.querySelector('body');
        body.insertAdjacentHTML('beforeend', modal);
    }

    const modalHtml = (content, id) => {
        return `
            <div class="modal fade show d-flex" id="${id}" tabindex="-1" aria-hidden="false">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            ${content}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    const removeModalActiveClass = (modal) => {
        modal.classList.remove('show', 'd-flex');
        modal.classList.add('hide');
        toggleVideoIfModalHasVideo(modal, 'pause');
    }

    const addModalActiveClass = (modal) => {
        modal.classList.remove('hide', 'd-none');
        modal.classList.add('show', 'd-flex');
        toggleVideoIfModalHasVideo(modal, 'play');
    }

    const toggleVideoIfModalHasVideo = (modal, status) => {
        const video = modal.querySelector('video');
        if(!video) {
            return;
        }

        switch(status) {
            case 'pause':
                video.pause();
                break;
            case 'play':
                video.play();
                break;
        }
    }
    

    const findModalById = (id) => {
        const modal = document.getElementById(id);
        if(!modal) {
            return;
        }

        return modal;
    }

    async function modalHandler(e) {
        e.preventDefault();
        
        const { target } = e
        const item = ! target.dataset.modal ? target.closest('[data-modal]') : target;
        const modalId = item.dataset?.modal;
        const modal = findModalById(modalId);

        if (!modal) {
            return;
        }

        addModalActiveClass(modal);
        document.querySelector('html').classList.add('overflow-hidden');

        const modalContent = await getModalContent(modalId);
        if (!modalContent) {
            return;
        }

        appendModal(
            modalHtml(modalContent, modalId)
        );
    }

    const removeModalOnExitButton = (e) => {
        if (!e.target.dataset?.bsDismiss) {
            return;
        }

        const modal = e.target.closest('.modal');
        removeModalActiveClass(modal);
        document.querySelector('html').classList.remove('overflow-hidden');
    }

    const removeModalOnOutside = (e) => {
        if (!e.target.classList.contains('modal')) {
            return;
        }
        removeModalActiveClass(e.target);
        document.querySelector('html').classList.remove('overflow-hidden');
    }

    const removeBodyModal = (e) => {
        removeModalOnExitButton(e);
        removeModalOnOutside(e);
    }

    const removeExitModalKeyboard = (e) => {
        if(e.key !== 'Escape') {
            return;
        }
        const modal = document.querySelector('.modal');
        removeModalActiveClass(modal);
    }

    modalTriggers.forEach(trigger => trigger.addEventListener('click', modalHandler));

    document.body.addEventListener('click', removeBodyModal);
    document.addEventListener('keydown', removeExitModalKeyboard)
}
